function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ItemMemberLevel } from "sprout-graphql";
import { memo, useCallback } from "react";
import { Flex, Text } from "sprout-ui-primitives";
import styled, { css } from "styled-components";
import { media } from "sprout-ui-theme";
import { getItemUrl } from "sprout-lib";
import { Card as BaseCard, CardContent, CardLink } from "@sprout/client-components/dist/Card";
import { GitBranchLine, LeafLine } from "sprout-ui-icons";
import { usePopoverDialogState } from "sprout-ui-dom/dist/PopoverDialog";
import { CreateSectionPopoverDialog } from "@sprout/client-components/dist/PopoverDialog";
import { PopoverReference, PopoverTrigger } from "sprout-ui-dom/dist/Popover";
import { useMenuState } from "@sprout/list-navigation/dist/Menu";
import { useTopicPageViewsTopicEditor } from "../TopicPage_Views_Topic/TopicPageViewsTopicEditorContext";
import TopicPageSectionExpandButton from "./TopicPageSectionExpandButton";
import TopicPageSectionMenu from "./TopicPageSectionMenu";
import TopicPageSectionInput from "./TopicPageSectionInput";
import TopicPageSectionSectionButton from "./TopicPageSectionSectionButton";
const TopicPageSectionActionsWrapper = styled(Flex)`
  ${({ $open  })=>!$open && css`
      display: none;
    `}
`;
const Card = styled(BaseCard)`
  ::before,
  ::after {
    content: none;
  }

  ${media.down("medium")} {
    padding: 8px 0;
  }

  ${media.up("medium")} {
    padding: 10px 0;
  }

  ${media.up("medium", "pointer")} {
    :hover ${TopicPageSectionActionsWrapper} {
      display: inline-flex;
    }
  }
`;
const TextWrapper = styled(Flex)`
  ${media.down("medium")} {
    flex-direction: column;
  }

  ${media.up("medium")} {
    align-items: center;
  }
`;
const CountWrapper = styled(Text)`
  flex-shrink: 0;

  ${media.down("medium")} {
    margin-top: 4px;
  }

  ${media.up("medium")} {
    margin-left: 16px;
  }
`;
const TopicPageSectionSection = (props)=>{
    const { section , expandable , isExpanded , navigationListItemProvided , onExpand , isDragging , isGroupedOver ,  } = props;
    const { title , rootTopic , id  } = section;
    const { owner , memberLevel  } = rootTopic || {};
    const directPostCount = section.directPostCount || 0;
    const directSubtopicCount = section.directSubtopicCount || 0;
    const hasPosts = !!directPostCount;
    const hasSubtopics = !!directSubtopicCount;
    const { navProps , helpers  } = navigationListItemProvided || {};
    const _ref = navProps || {}, { ref  } = _ref, navRest = _objectWithoutProperties(_ref, [
        "ref"
    ]);
    const { isActive =false  } = helpers || {};
    const sectionURL = getItemUrl(section, owner);
    const isPartOfTopic = memberLevel && [
        ItemMemberLevel.Owner,
        ItemMemberLevel.Admin,
        ItemMemberLevel.Contributor, 
    ].includes(memberLevel);
    const showButton = isPartOfTopic && !isDragging && expandable;
    const { state , dispatch  } = useTopicPageViewsTopicEditor();
    const { editor , editorPosition , variant  } = state;
    const editMode = editor === "EDIT_TOPIC" && editorPosition === section.id;
    const createMode = editor === "CREATE_POST" && editorPosition === section.id;
    const handleAddClick = useCallback(()=>{
        dispatch({
            type: "SET_EDITOR",
            payload: {
                editor: "CREATE_POST",
                editorPosition: id,
                variant: "desktop"
            }
        });
    }, [
        dispatch,
        id
    ]);
    //
    const popoverDialogState = usePopoverDialogState();
    const menuState = useMenuState();
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(CreateSectionPopoverDialog, _objectSpread({
                topicId: id,
                placement: "bottom"
            }, popoverDialogState)),
            /*#__PURE__*/ _jsxs(Card, _objectSpread({
                ref: ref,
                isExpanded: isExpanded,
                isActive: isActive,
                isGroupedOver: isGroupedOver,
                isDragging: isDragging
            }, navRest, {
                children: [
                    /*#__PURE__*/ _jsx(TopicPageSectionInput, {
                        section: section,
                        open: editMode ? variant : undefined
                    }),
                    !(editMode && variant === "desktop") && /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            showButton && /*#__PURE__*/ _jsx(TopicPageSectionExpandButton, {
                                isExpanded: isExpanded,
                                onClick: onExpand,
                                variant: "desktop"
                            }),
                            /*#__PURE__*/ _jsx(CardLink, {
                                to: sectionURL
                            }),
                            /*#__PURE__*/ _jsxs(CardContent, {
                                as: Flex,
                                alignItems: "center",
                                children: [
                                    showButton && /*#__PURE__*/ _jsx(TopicPageSectionExpandButton, {
                                        isExpanded: isExpanded,
                                        onClick: onExpand,
                                        variant: "mobile"
                                    }),
                                    /*#__PURE__*/ _jsxs(TextWrapper, {
                                        minWidth: "0",
                                        pr: 1,
                                        flex: "1",
                                        children: [
                                            /*#__PURE__*/ _jsx(Text, {
                                                truncate: true,
                                                fontWeight: "bold",
                                                fontSize: "18px",
                                                children: title || "No title"
                                            }),
                                            !isExpanded && (hasPosts || hasSubtopics) && /*#__PURE__*/ _jsxs(CountWrapper, {
                                                truncate: true,
                                                fontSize: 1,
                                                color: "black.60",
                                                children: [
                                                    hasPosts && `${directPostCount} ${directPostCount > 1 ? "leaves" : "leaf"}`,
                                                    hasPosts && hasSubtopics && " · ",
                                                    hasSubtopics && `${directSubtopicCount} branch${directSubtopicCount > 1 ? "es" : ""}`
                                                ]
                                            })
                                        ]
                                    }),
                                    showButton && /*#__PURE__*/ _jsxs(TopicPageSectionActionsWrapper, {
                                        alignItems: "center",
                                        bg: "blue.40",
                                        borderRadius: "8px",
                                        p: "2px",
                                        my: "-10px",
                                        $open: popoverDialogState.open || menuState.open !== false,
                                        children: [
                                            !createMode && isExpanded && /*#__PURE__*/ _jsx(TopicPageSectionSectionButton, {
                                                onClick: handleAddClick,
                                                children: /*#__PURE__*/ _jsx(LeafLine, {})
                                            }),
                                            /*#__PURE__*/ _jsx(PopoverReference, _objectSpread({}, popoverDialogState, {
                                                children: /*#__PURE__*/ _jsx(PopoverTrigger, _objectSpread({}, popoverDialogState, {
                                                    children: /*#__PURE__*/ _jsx(TopicPageSectionSectionButton, {
                                                        children: /*#__PURE__*/ _jsx(GitBranchLine, {})
                                                    })
                                                }))
                                            })),
                                            /*#__PURE__*/ _jsx(TopicPageSectionMenu, {
                                                section: section,
                                                menuState: menuState
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }))
        ]
    });
};
export default /*#__PURE__*/ memo(TopicPageSectionSection);
